import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page" className="bg-[#0A0A0C] text-white py-20">
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.3em] uppercase text-[#E85D04] mb-6">Field Stories</div>
        <h1 className="font-serif-display text-5xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl">
          Dispatches from the front lines.
        </h1>
      </section>

      <section className="mt-20 max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p, i) => (
          <article
            key={p.id}
            data-testid={`blog-card-${i}`}
            onClick={() => setActive(p)}
            className="group cursor-pointer border border-white/10 bg-[#121215] overflow-hidden hover:-translate-y-1 transition-transform"
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(${p.image_url})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C]/70 to-transparent" />
            </div>
            <div className="p-6">
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-3">
                {p.author}
              </div>
              <h2 className="font-serif-display text-2xl leading-tight group-hover:text-[#E85D04] transition-colors">
                {p.title}
              </h2>
              <p className="mt-3 text-white/60 text-sm leading-relaxed">{p.excerpt}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-[#E85D04]">
                Read story <ArrowUpRight size={12} />
              </div>
            </div>
          </article>
        ))}
        {posts.length === 0 && (
          <div className="col-span-full text-white/40 text-center py-20" data-testid="blog-empty">
            No stories yet — check back soon.
          </div>
        )}
      </section>

      {active && (
        <div
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md p-6 overflow-y-auto"
          onClick={() => setActive(null)}
          data-testid="blog-modal"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="max-w-3xl mx-auto bg-[#121215] border border-white/10 mt-10"
          >
            <div className="relative aspect-[16/9] overflow-hidden">
              <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${active.image_url})` }} />
            </div>
            <div className="p-8 lg:p-12">
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#E85D04] mb-4">{active.author}</div>
              <h2 className="font-serif-display text-4xl lg:text-5xl leading-tight">{active.title}</h2>
              <div className="mt-6 text-white/70 leading-relaxed whitespace-pre-line">{active.body}</div>
              <button
                onClick={() => setActive(null)}
                data-testid="blog-modal-close"
                className="mt-10 text-xs tracking-[0.22em] uppercase text-white/60 hover:text-white"
              >
                Close ×
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
